const InstanceGuardWait = [];
export function InstanceGuard(Model, props, call) {
    if (call) {
        InstanceGuardWait.push({ Model, props });
        return call();
    }
    else {
        const last = InstanceGuardWait[InstanceGuardWait.length - 1];
        if (last.Model === Model && last.props === props) {
            InstanceGuardWait.pop();
            return true;
        }
        return false;
    }
}
